'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a title heading followed by text.  If no text supplied,
 * nothing renders.
 */
var TitleAndText = function (_React$Component) {
	_inherits(TitleAndText, _React$Component);

	function TitleAndText() {
		_classCallCheck(this, TitleAndText);

		return _possibleConstructorReturn(this, (TitleAndText.__proto__ || Object.getPrototypeOf(TitleAndText)).apply(this, arguments));
	}

	_createClass(TitleAndText, [{
		key: 'render',
		value: function render() {
			if (!this.state.text) {
				return null;
			}
			return _react2.default.createElement(
				'div',
				{ className: 'ux-container' },
				_react2.default.createElement(
					'h4',
					null,
					this.state.heading
				),
				_react2.default.createElement(
					'p',
					null,
					this.state.text
				)
			);
		}
	}]);

	return TitleAndText;
}(_react2.default.Component);

TitleAndText.propTypes = {
	/**
  * A heading to display.
  */
	heading: _propTypes2.default.string.isRequired,

	/**
  * The text to display.
  */
	text: _propTypes2.default.string
};

var _default = TitleAndText;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(TitleAndText, 'TitleAndText', 'src/components/SwaggerUI/TitleAndText.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/SwaggerUI/TitleAndText.jsx');
}();

;